module.exports = __webpack_public_path__ + "media/images/demo/horizontal-menu-dark-27e8db69002a66bfe92138973c0a4449.jpg";